import React__default from 'react';
import { useUID } from '@amzn/storm-ui';
import { a as NumericOption$1 } from './NumericOption-BEP7gL-p.js';
import { N as NumericOption } from './Numeric10Option-BizmqxOy.js';
import { E as EmojiOption } from './EmojiOption-Bed0m1rL.js';
import { v as variant } from './variant-K-YUik8y.js';

function Option({
  variant: variant$1,
  id,
  ...optionProps
}) {
  const uid = useUID(id);
  const props = {
    ...optionProps,
    id: uid
  };
  if (variant$1 === variant.emoji) {
    return /*#__PURE__*/React__default.createElement(EmojiOption, props);
  }
  if (variant$1 === variant['numeric-10']) {
    return /*#__PURE__*/React__default.createElement(NumericOption, props);
  }
  return /*#__PURE__*/React__default.createElement(NumericOption$1, props);
}

export { Option as O };
//# sourceMappingURL=Option-CN0ABx5E.js.map
